var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contaier"},[_c('router-view',{key:_vm.key}),_c('LayoutBottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }